export default "<app-table [inputConfig]=\"tableConfig\"></app-table>\n"